import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { useTheme } from '@mui/material/styles';
import { useThemeCont } from '../../contexts/ThemeContext';

//utilities
import { useTranslation } from 'react-i18next';
import {
  DarkModeOutlined,
  LightModeOutlined,
  LogoutOutlined,
  SettingsOutlined,
  TranslateOutlined,
} from '@mui/icons-material';
import {
  fetchBusinessData,
  setCurrentSection,
  setCurrentUser,
} from '../../redux/actions-v2/coreAction';

const UserSecMenu = ({ isMobile, orientation = 'vertical' }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mode, toggleTheme } = useThemeCont();
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === 'dark';

  const currentUser = useSelector((state) => state.core.user);

  const businessPreference = useSelector((state) => state.core.businessData);
  const currentPlatform = useSelector(state => state.core.currentPlatform);


  const handleUpdateLang = () => {
    localStorage.setItem('i18nextLng', i18n.language === 'fr' ? 'en' : 'fr');
    i18n.changeLanguage(i18n.language === 'fr' ? 'en' : 'fr');
    dispatch(fetchBusinessData(businessPreference.id, t, null, null, currentPlatform));
  };

  const handleNavigateSettings = useCallback((section) => {
    dispatch(setCurrentSection('SETTINGS'));
    navigate('/app/settings');
  }, []);

  const handleLogout = async () => {
    try {
      dispatch(setCurrentUser(null, ''));
      sessionStorage.removeItem('businesses');
      sessionStorage.removeItem('businessToken');
      sessionStorage.removeItem('unseenMessages');
      const auth = getAuth();
      await signOut(auth);
      navigate('/signin');
    } catch (error) {
      console.error(error);
    }
  };

  const menuContainerStyle = {
    display: 'flex',
    flexDirection: orientation === 'vertical' ? 'column' : 'row',
    alignItems: orientation === 'vertical' ? 'flex-start' : 'center',
    gap: orientation === 'vertical' ? '16px' : '8px',
    padding: orientation === 'vertical' ? '16px 0' : '0 16px',
  };

  const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: orientation === 'vertical' ? '8px 16px' : '6px',
    width: orientation === 'vertical' ? '100%' : 'auto',
  };

  return (
    <div className="hover">
      <div style={menuContainerStyle}>
        <div style={menuItemStyle} onClick={toggleTheme}>
          {isDarkMode ? (
            <LightModeOutlined
              color={isDarkMode ? 'white' : 'black'}
              style={{ fontSize: 16 }}
            />
          ) : (
            <DarkModeOutlined
              color={isDarkMode ? 'white' : 'black'}
              style={{ fontSize: 16 }}
            />
          )}
        </div>
        <div style={menuItemStyle} onClick={handleUpdateLang}>
          <TranslateOutlined
            color={isDarkMode ? 'white' : 'black'}
            style={{ fontSize: 16 }}
          />
        </div>
        {(currentUser?.activeBusiness?.role === 'ADMIN' ||
          currentUser?.activeBusiness?.role === 'SUPER-ADMIN') && (
            <div style={menuItemStyle} onClick={handleNavigateSettings}>
              <SettingsOutlined
                color={isDarkMode ? 'white' : 'black'}
                style={{ fontSize: 16 }}
              />
            </div>
          )}
        <div style={menuItemStyle} onClick={handleLogout}>
          <LogoutOutlined
            color={isDarkMode ? 'white' : 'black'}
            style={{ fontSize: 16 }}
          />
        </div>

      </div>
    </div>
  );
};

export default UserSecMenu;
